/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmissionRate } from './EmissionRate';
import {
    EmissionRateFromJSON,
    EmissionRateFromJSONTyped,
    EmissionRateToJSON,
    EmissionRateToJSONTyped,
} from './EmissionRate';
import type { Emission } from './Emission';
import {
    EmissionFromJSON,
    EmissionFromJSONTyped,
    EmissionToJSON,
    EmissionToJSONTyped,
} from './Emission';

/**
 * Alerting data for a device.
 * @export
 * @interface AlertingData
 */
export interface AlertingData {
    /**
     * 
     * @type {string}
     * @memberof AlertingData
     */
    emissionId: string;
    /**
     * 
     * @type {Emission}
     * @memberof AlertingData
     */
    emission: Emission;
    /**
     * 
     * @type {Array<EmissionRate>}
     * @memberof AlertingData
     */
    rates: Array<EmissionRate>;
}

/**
 * Check if a given object implements the AlertingData interface.
 */
export function instanceOfAlertingData(value: object): value is AlertingData {
    if ((!('emissionId' in (value as Record<string, any>)) && !('emission_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionId'] === undefined && (value as Record<string, any>)['emission_id'] === undefined)) return false;
    if (!('emission' in value) || value['emission'] === undefined) return false;
    if (!('rates' in value) || value['rates'] === undefined) return false;
    return true;
}

export function AlertingDataFromJSON(json: any): AlertingData {
    return AlertingDataFromJSONTyped(json, false);
}

export function AlertingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertingData {
    if (json == null) {
        return json;
    }
    return {
        
        'emissionId': json['emission_id'],
        'emission': EmissionFromJSON(json['emission']),
        'rates': ((json['rates'] as Array<any>).map(EmissionRateFromJSON)),
    };
}

export function AlertingDataToJSON(json: any): AlertingData {
    return AlertingDataToJSONTyped(json, false);
}

export function AlertingDataToJSONTyped(value?: AlertingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emission_id': value['emissionId'],
        'emission': EmissionToJSON(value['emission']),
        'rates': ((value['rates'] as Array<any>).map(EmissionRateToJSON)),
    };
}

